'use strict';

import angular from 'angular';
import EditController from './edit.controller';

export default angular.module('updateServerApp.myscripts.edit', [])
  .controller('MyScriptsEditController', EditController)
  .name;



// WEBPACK FOOTER //
// ./client/app/myscripts/edit/index.js